export const TopicConstants = {
    GETALL_REQUEST: 'TOPIC_GETALL_REQUEST',
    GETALL_SUCCESS: 'TOPIC_GETALL_SUCCESS',
    GETALL_FAILURE: 'TOPIC_GETALL_FAILURE' 
};



// WEBPACK FOOTER //
// ./src/_constants/topic.constants.js